import { createRoot } from "react-dom/client";
import { App, registrarServiceWorker } from "@hugi/ui";
import { Aplicacao } from "./Aplicacao.js";
import "./estilo.css";

/**
 * Para onde mandar quem nao tem sessao.
 *
 * Vem do ambiente de build porque o endereco do Cert4All difere entre dev e producao, e um valor
 * fixo aqui mandaria o cliente para o login errado — o pior lugar para descobrir configuracao
 * errada. Sem a variavel, cai na raiz do proprio host, que ao menos nao leva a lugar nenhum
 * enganoso.
 */
const URL_DE_LOGIN = import.meta.env["VITE_URL_DE_LOGIN"] ?? "/";

// O service worker (H46): instalar no Android, e receber os avisos no celular.
registrarServiceWorker(import.meta.env.PROD);

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("elemento #raiz ausente no index.html");

createRoot(raiz).render(
  <App urlDeLogin={URL_DE_LOGIN}>
    <Aplicacao />
  </App>,
);
